import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { WorkflowStepApiResponse, fetchWorkflowStepsById } from 'api/workflows';
import { AxiosError } from 'axios';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentWorkflow } from 'customHooks/useCurrentWorkflow';
import { workflowQueryKeys } from 'queries/workflow-query-keys';

interface UseCurrentWorkflowStepsOptions
    extends Omit<
        UseSuspenseQueryOptions<
            WorkflowStepApiResponse[],
            AxiosError,
            WorkflowStepApiResponse[],
            any
        >,
        'queryKey' | 'queryFn'
    > {
    workflowId?: number;
    version?: number;
}

const useCurrentWorkflowSteps = (options: UseCurrentWorkflowStepsOptions = {}) => {
    const { workflowId: id, version, retry = false, ...rest } = options;
    const { accountId } = useCurrentAccount();
    const { data: workflow } = useCurrentWorkflow();
    const workflowId = id ?? Number(workflow.id);

    const params = {
        version: version ?? workflow.current_version,
    };

    return useSuspenseQuery({
        queryKey: workflowQueryKeys.workflowStepsByIdWithFilters(accountId, workflowId, params),
        queryFn: () => fetchWorkflowStepsById(accountId, workflowId, params),
        retry,
        ...rest,
        refetchOnWindowFocus: 'always',
    });
};

export { useCurrentWorkflowSteps };
